import React, { createContext, useEffect, useRef, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Header from "./Header";
import Footer from "./Footer";
import PubSub from "pubsub-js";
import scrollIntoView from "scroll-into-view";
import CursorLogo from "./ui/CursorLogo";
import ProductDrop from "./shop/ProductDrop";
import CookieConsent from "./ui/CookieConsent";
import { debounce } from "throttle-debounce";
// import ScreenSaverDvd from "./ui/ScreenSaverDvd";
// import logoBall from "../images/asphalt-chronicles-logo-ball.svg";

const WrapperContext = createContext();

const query = graphql`
  query {
    siteBuildMetadata {
      buildTime
    }
    sanityProduct(productDrop: { dropDate: { gt: "0" } }) {
      slug {
        current
      }
      title
      images: _rawImages(resolveReferences: { maxDepth: 10 })
      productDrop {
        title
        infos
        dropDate
      }
    }
  }
`;

const Layout = ({ children, location, pageContext: { template, isHome } }) => {
  const {
    //siteBuildMetadata,
    sanityProduct
  } = useStaticQuery(query);

  const [isMobile, setIsMobile] = useState(undefined);
  const scrollerRef = useRef();
  const sectionWidth = useRef(0);

  const _onWheel = e => {
    console.log(e.target.parentNode.classList);
    // if (e.target.nodeName === "DIV" || e.target.nodeName === "P") return;
    // if (e.target.parents(".scrollY").length) return;
    if (!e.deltaY) return;

    e.currentTarget.scrollLeft += e.deltaY + e.deltaX;
    e.preventDefault();

    // e.preventDefault();
    // if (isMobile) return;

    // return;

    // const { deltaY } = e;
    // console.log(deltaY);
    // if (deltaY < 1) _onNext();
    // else if (deltaY > 1) _onPrev();
    // return;

    // const rawData = e.wheelDelta;
    // console.log(rawData);
    // const mouseX = Math.floor(rawData) * 0.4;
    // scrollerRef.current.scrollLeft -= mouseX;
  };

  // const _onWheelDebounce = debounce(0, false, _onWheel);

  useEffect(() => {
    // console.log(sanityProduct);
    _format();

    window.addEventListener("resize", _format);
    // scrollerRef.current.addEventListener("wheel", _onWheel, true);
    const tokenPrev = PubSub.subscribe("KB_PREV", _onPrev);
    const tokenNext = PubSub.subscribe("KB_NEXT", _onNext);

    const tokenRu = PubSub.subscribe("ROUTE_UPDATE", e => {
      if (scrollerRef.current && scrollerRef.current.firstChild) {
        scrollIntoView(
          scrollerRef.current.firstChild,
          {
            time: 500,
            align: {
              left: 0
            }
          },
          () => {
            console.log("scroll callback");
          }
        );
      }
    });

    return () => {
      window.removeEventListener("resize", _format);
      // scrollerRef.current.removeEventListener("wheel", _onWheel);
      PubSub.unsubscribe(tokenRu);
      PubSub.unsubscribe(tokenPrev);
      PubSub.unsubscribe(tokenNext);
    };
  }, []);

  const _format = () => {
    if (window.innerWidth < 982 && "ontouchstart" in window) setIsMobile(true);

    document.documentElement.style.setProperty(
      "--appHeight",
      window.innerHeight + "px"
    );

    sectionWidth.current = document
      .querySelector("section.section")
      .getBoundingClientRect().width;
  };

  const _onPrev = () => {
    scrollerRef.current.scrollBy({
      top: 0,
      left: -sectionWidth.current,
      behavior: "smooth"
    });
  };
  const _onNext = () => {
    scrollerRef.current.scrollBy({
      top: 0,
      left: sectionWidth.current,
      behavior: "smooth"
    });
  };

  return (
    <WrapperContext.Provider value={{ location, isHome, isMobile }}>
      <div id='page'>
        <Header />
        <main>
          <div
            className='modules vh100 md:flex md:flex-row md:flex-nowrap scrollX'
            ref={scrollerRef}>
            {children}
            <section className='footer section'>
              <Footer />
            </section>
            {sanityProduct && <ProductDrop input={sanityProduct} />}
          </div>
        </main>
        <CookieConsent />
      </div>
      {!isMobile && <CursorLogo />}
      {/* <ScreenSaverDvd src={logoBall} width={316} height={36} /> */}
    </WrapperContext.Provider>
  );
};

export { WrapperContext, Layout };
